import { keepPreviousData, useQuery } from "@tanstack/react-query";

import useToastOnError from "@/modules/common/hooks/useToastOnError";
import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";
import { ListAdminManagementCompaniesManagerUsersDto } from "@/service/dto/admin-management-companies";

const useManagerUsersList = (id: string, params: ListAdminManagementCompaniesManagerUsersDto) => {
  const query = useQuery({
    queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGER_USERS(id), params],
    queryFn: () => AdminManagementCompaniesService.getManagerUsers(id, params),
    placeholderData: keepPreviousData,
    retry: false,
  });

  useToastOnError(query.isError, query.error, "Erro ao carregar usuários da gestora.");

  return query;
};

export default useManagerUsersList;
